import { defineStore } from "pinia";
import { instance } from "../index";
import { useAuthStore } from "../auth";
import { ObjectivesRest } from "@/services/rest/objectives.rest";
import { useAdaptCourseStore } from "./adapt-course";

export enum StatusMaterials {
  NEXT = "next",
  MORE = "more-materials",
  QUIZ = "quiz-materials",
}

export const store = defineStore({
  id: "learning-objective",
  state: () => ({
    learningObjective: {} as any,
    hasFinished: false,
  }),
  actions: {
    setLearningObjective(learningObjective: any) {
      this.learningObjective = {
        ...learningObjective,
        nameStudent: useAuthStore?.getData?.userName,
      };
    },
    nextObjective(): void {
      const data = {
        learningObjectiveId: this.learningObjective.id,
        clientTime: new Date(),
      };
      const classroomId = localStorage.getItem("classId") ?? undefined;
      new ObjectivesRest()
        .nextObjective(
          useAdaptCourseStore?.course.courseId,
          useAuthStore?.data.id,
          data,
          {
            classroomId,
          }
        )
        .subscribe({
          next: (response) => {},
          error: (e) => {},
        });
    },
  },
  getters: {
    getCurrentObjectiveId(state): string {
      return this.getStatus === StatusMaterials.QUIZ
        ? state?.learningObjective?.id
        : "";
    },
    getStatus(state): string {
      return state.learningObjective?.status ?? "NEXT";
    },
  },
});
export const useLearningObjectiveStore = store(instance);
